<template>
  <Section>

    <Container>

      <FadeIn class="max-w-2xl">
        <!-- <div class="mb-2 md:mb-4">
          <span class="rounded-full mr-2 sm:mr-0 mb-2 sm:mb-0 bg-[#5a6ded] px-2 py-0 text-xs inline-block font-semibold leading-6 text-white no-underline">
            Team
          </span>
        </div> -->
        <h2 class="text-section-title">Built with decades of triage and dispute resolution experience</h2>
        <p class="text-subtitle">Elker brings together problem solvers, developers and designers with experience in making it easy to speak up.</p>
      </FadeIn>

      <FadeIn class="max-w-2xl mt-20">
        <h2 class="text-h3">Operations team</h2>
        <!-- <p class="text-subtitle">The people responsible for putting the pieces together and making client and reporter processes simple and secure.</p> -->
      </FadeIn>

      <FadeIn>
        <ul role="list" class="mx-auto mt-20 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          <li v-for="person in teamMembers" :key="person.title">
            <span
            v-if="person.hasPage"
            class="cursor-pointer"
            @click="selected = person.slug"
            >
              <img loading="lazy" class="mx-auto md:h-56 md:w-56 rounded-full" :src="useCdn(person.image.id, person.image.filename_download)" :alt="'Elker team: '+ person.title" />
              <h3 class="mt-6 text-base font-semibold leading-7 tracking-tight text-gray-900 text-center">{{ person.title }}</h3>
              <p class="text-sm leading-6 text-gray-600 text-center">{{ person.position }}</p>
            </span>
            <template v-else>
              <img loading="lazy" class="mx-auto md:h-56 md:w-56 rounded-full" :src="useCdn(person.image.id, person.image.filename_download)" :alt="'Elker team: '+ person.title" />
              <h3 class="mt-6 text-base font-semibold leading-7 tracking-tight text-gray-900 text-center">{{ person.title }}</h3>
              <p class="text-sm leading-6 text-gray-600 text-center">{{ person.position }}</p>
            </template>
            <template v-if="person.hasPage">
              <TransitionRoot as="template" :show="selected === person.slug">
                <Dialog as="div" class="relative z-10" @close="selected = null">
                  <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                  </TransitionChild>
                  <div class="fixed inset-0 z-10 overflow-y-auto">
                    <div class="flex min-h-full justify-center p-4 text-center items-center">
                      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel class="relative transform overflow-hidden rounded-lg bg-[#f9f8f6] text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                          <div class="bg-[#f9f8f6] p-6 sm:p-6 lg:p-8 prose">
                            <div>
                              <div class="mt-3 prose">
                                <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900 mt-0">
                                  {{ person.title }}
                                </DialogTitle>
                                <div class="mt-2">
                                  <div class="text-sm" v-interpolation v-html="useSanitize(person.bio, currentLocale)"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </DialogPanel>
                      </TransitionChild>
                    </div>
                  </div>
                </Dialog>
              </TransitionRoot>
            </template>
          </li>
        </ul>
      </FadeIn>
      
      <FadeIn class="max-w-2xl mt-20">
        <h2 class="text-h3">Board</h2>
        <!-- <p class="text-subtitle">A diverse board to keep the business safe and strategic.</p> -->
      </FadeIn>

      <FadeIn>
        <ul role="list" class="mx-auto mt-20 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          <li v-for="person in boardMembers" :key="person.title">
            <span
            v-if="person.hasPage"
            class="cursor-pointer"
            @click="selected = person.slug"
            >
              <img loading="lazy" class="mx-auto md:h-56 md:w-56 rounded-full" :src="useCdn(person.image.id, person.image.filename_download)" :alt="'Elker team: '+ person.title" />
              <h3 class="mt-6 text-base font-semibold leading-7 tracking-tight text-gray-900 text-center">{{ person.title }}</h3>
              <p class="text-sm leading-6 text-gray-600 text-center">{{ person.position }}</p>
            </span>
            <template v-else>
              <img loading="lazy" class="mx-auto md:h-56 md:w-56 rounded-full" :src="useCdn(person.image.id, person.image.filename_download)" :alt="'Elker team: '+ person.title" />
              <h3 class="mt-6 text-base font-semibold leading-7 tracking-tight text-gray-900 text-center">{{ person.title }}</h3>
              <p class="text-sm leading-6 text-gray-600 text-center">{{ person.position }}</p>
            </template>
            <template v-if="person.hasPage">
              <TransitionRoot as="template" :show="selected === person.slug">
                <Dialog as="div" class="relative z-10" @close="selected = null">
                  <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                  </TransitionChild>
                  <div class="fixed inset-0 z-10 overflow-y-auto">
                    <div class="flex min-h-full justify-center p-4 text-center items-center">
                      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel class="relative transform overflow-hidden rounded-lg bg-[#f9f8f6] text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                          <div class="bg-[#f9f8f6] p-6 sm:p-6 lg:p-8 prose">
                            <div>
                              <div class="mt-3 prose">
                                <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900 mt-0">
                                  {{ person.title }}
                                </DialogTitle>
                                <div class="mt-2">
                                  <div class="text-sm" v-interpolation v-html="useSanitize(person.bio, currentLocale)"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </DialogPanel>
                      </TransitionChild>
                    </div>
                  </div>
                </Dialog>
              </TransitionRoot>
            </template>
          </li>
        </ul>
      </FadeIn>
      
      <FadeIn class="max-w-2xl mt-20">
        <h2 class="text-h3">Consultants</h2>
        <!-- <p class="text-subtitle">Our expert network of consultants providing additional support for clients.</p> -->
      </FadeIn>

      <FadeIn>
        <ul role="list" class="mx-auto mt-20 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          <li v-for="person in consultants" :key="person.title">
            <span
            v-if="person.hasPage"
            class="cursor-pointer"
            @click="selected = person.slug"
            >
              <img loading="lazy" class="mx-auto md:h-56 md:w-56 rounded-full" :src="useCdn(person.image.id, person.image.filename_download)" :alt="'Elker team: '+ person.title" />
              <h3 class="mt-6 text-base font-semibold leading-7 tracking-tight text-gray-900 text-center">{{ person.title }}</h3>
              <p class="text-sm leading-6 text-gray-600 text-center">{{ person.position }}</p>
            </span>
            <template v-else>
              <img loading="lazy" class="mx-auto md:h-56 md:w-56 rounded-full" :src="useCdn(person.image.id, person.image.filename_download)" :alt="'Elker team: '+ person.title" />
              <h3 class="mt-6 text-base font-semibold leading-7 tracking-tight text-gray-900 text-center">{{ person.title }}</h3>
              <p class="text-sm leading-6 text-gray-600 text-center">{{ person.position }}</p>
            </template>
            <template v-if="person.hasPage">
              <TransitionRoot as="template" :show="selected === person.slug">
                <Dialog as="div" class="relative z-10" @close="selected = null">
                  <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                  </TransitionChild>
                  <div class="fixed inset-0 z-10 overflow-y-auto">
                    <div class="flex min-h-full justify-center p-4 text-center items-center">
                      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel class="relative transform overflow-hidden rounded-lg bg-[#f9f8f6] text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                          <div class="bg-[#f9f8f6] p-6 sm:p-6 lg:p-8 prose">
                            <div>
                              <div class="mt-3 prose">
                                <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900 mt-0">
                                  {{ person.title }}
                                </DialogTitle>
                                <div class="mt-2">
                                  <div class="text-sm" v-interpolation v-html="useSanitize(person.bio, currentLocale)"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </DialogPanel>
                      </TransitionChild>
                    </div>
                  </div>
                </Dialog>
              </TransitionRoot>
            </template>
          </li>
        </ul>
      </FadeIn>

    </Container>

  </Section>
</template>

<script setup>
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'

const selected = ref(null)

const { getItems } = useCms()
const fields = useFields()
const { data } = await useAsyncData(
  'block-team',
  () => getItems({
    collection: 'person',
    params: {
      fields
    },
  })
)

const team = computed(() => data?.value)

// Filter out 'team'
const teamMembers = computed(() => {
  return team.value.filter(member => member.type === 'team')
})

// Filter out 'board'
const boardMembers = computed(() => {
  return team.value.filter(member => member.type === 'board')
})

// Filter out 'consultants'
const consultants = computed(() => {
  return team.value.filter(member => member.type === 'consultants')
})

const route = useRoute()
const currentLocale = computed(() => {
  return route.path.startsWith('/nz') ? 'nz' : 'au'
})

</script>